"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = void 0;
var address_ui_1 = require("@newfront-insurance/address-ui");
var core_1 = require("@newfront-insurance/core");
var core_ui_1 = require("@newfront-insurance/core-ui");
var text_1 = require("@newfront-insurance/core-ui/dist/src/components/text");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var find_1 = __importDefault(require("lodash/find"));
var react_1 = __importDefault(require("react"));
var getStringifiedFieldValue_1 = require("../utils/getStringifiedFieldValue");
var registry_1 = require("./registry");
function Value(_a) {
    var _b;
    var name = _a.name, value = _a.value, field = _a.field, _c = _a.size, size = _c === void 0 ? 'regular' : _c, _d = _a.color, color = _d === void 0 ? 'dark' : _d, _e = _a.weight, weight = _e === void 0 ? 300 : _e;
    var testId = "Value-" + name;
    var displayValue;
    var type = field.inputType, metadata = field.inputMetadata, properties = field.properties;
    switch (type) {
        // multi select is an exception for now because of the way it's displayed
        // we probably want to change it to display inline, comma separated, but for now it should be fine.
        case dsl_schema_api_1.InputType.MULTI_SELECT: {
            return (react_1.default.createElement(core_ui_1.Flexbox, { gap: 2, flexDirection: "column" }, (value === null || value === void 0 ? void 0 : value.map(function (item) {
                var _a;
                var option = (0, find_1.default)(metadata === null || metadata === void 0 ? void 0 : metadata.options, { value: item });
                var key = testId + "-" + item;
                return (react_1.default.createElement(text_1.Text, { size: size, color: color, weight: weight, testId: key, key: key }, (option === null || option === void 0 ? void 0 : option.label) + " " + ((_a = option === null || option === void 0 ? void 0 : option.description) !== null && _a !== void 0 ? _a : '')));
            })) || (react_1.default.createElement(text_1.Text, { size: size, color: color, weight: weight }, "-"))));
        }
        case dsl_schema_api_1.InputType.ADDRESS: {
            return value ? (react_1.default.createElement(address_ui_1.AddressFormattedText, { address: value })) : (react_1.default.createElement(text_1.Text, { prewrap: true, size: size, color: color, weight: weight, testId: testId }, displayValue || '-'));
        }
        case dsl_schema_api_1.InputType.ADDRESS_OR_STATE: {
            if (value === null || value === void 0 ? void 0 : value.address) {
                return react_1.default.createElement(address_ui_1.AddressFormattedText, { address: value.address });
            }
            if ((value === null || value === void 0 ? void 0 : value.state) && (properties === null || properties === void 0 ? void 0 : properties.state)) {
                displayValue = (0, getStringifiedFieldValue_1.getStringifiedFieldValue)(value === null || value === void 0 ? void 0 : value.state, properties.state);
            }
            break;
        }
        default: {
            // Check if there is a custom component for the type and use it if that is the case
            var CustomComponent = (_b = registry_1.customValueComponentsRegistry[type]) === null || _b === void 0 ? void 0 : _b.component;
            if (CustomComponent) {
                return react_1.default.createElement(CustomComponent, { name: name, value: value, field: field, size: size, color: color, weight: weight });
            }
            // fallback
            displayValue = (0, getStringifiedFieldValue_1.getStringifiedFieldValue)(value, field);
            break;
        }
    }
    return (react_1.default.createElement(text_1.Text, { prewrap: true, size: size, color: color, weight: weight, testId: testId }, displayValue || '-'));
}
exports.Value = Value;
/**
 * Allows to extend Value by adding new inputType handlers
 * @param inputType
 * @param customValue
 */
Value.registerComponent = function (inputType, customValue, customGetStringifiedFieldValue) {
    var previouslyRegisteredComponent = registry_1.customValueComponentsRegistry[inputType];
    if ((0, core_1.isNotNil)(previouslyRegisteredComponent)) {
        // eslint-disable-next-line no-console
        console.warn("Value.registerComponent for type \"" + inputType + "\" override. It was already set.");
    }
    registry_1.customValueComponentsRegistry[inputType] = {
        component: customValue,
        getStringifiedFieldValue: customGetStringifiedFieldValue,
    };
};
